import Vue from 'vue';
import confirm from './app-confirm.vue';

let newInstance = null;

//vue组件转换为构造函数
const ConfirmConstructor = Vue.extend(confirm);

const init = options => {
  //实例化组件
  newInstance = new ConfirmConstructor();
  //合并配置选项
  Object.assign(newInstance, options);
  //创建dom
  document.body.appendChild(newInstance.$mount().$el);
};

const caller = options => {
  if (!newInstance) {
    init(options);
  }
  return newInstance.show(() => {
    newInstance = null;
  });
};

export default {
  install(vue) {
    vue.prototype.$appConfirm = caller;
  }
};
